// extracted by mini-css-extract-plugin
export default {"container":"container___jTcct","title":"title___O94sl"};